<script setup lang="ts">
import { useAdminEdit } from '~/composables/useAdminEdit'

const props = defineProps<{
	to: string
	title?: string
	inline?: boolean
}>()

const { canEdit } = useAdminEdit()
</script>

<template>
	<a
		v-if="canEdit"
		:href="props.to"
		target="_blank"
		:title="props.title || 'Im CMS bearbeiten'"
		:class="props.inline ? 'admin-edit-link admin-edit-link--inline' : 'admin-edit-link'"
	>
		<v-icon name="ri-pencil-fill" class="h-5 w-5" fill="currentColor" />
	</a>
</template>

<style scoped>
.admin-edit-link {
	position: absolute;
	top: -0.5rem;
	right: -0.5rem;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 2.5rem;
	height: 2.5rem;
	border-radius: 9999px;
	color: white;
	background: var(--rot, #c0392b);
	border: 2px solid white;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
	cursor: pointer;
	transition: all 0.15s;
	z-index: 10;
}
.admin-edit-link--inline {
	position: static;
}
.admin-edit-link:hover {
	background: color-mix(in srgb, var(--rot, #c0392b) 80%, black);
	transform: scale(1.1);
}
</style>
